import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'
import { showCurrencyFormat } from '../../../../utils';
import NumericLabel from 'react-pretty-numbers';
import { Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { titanInstance } from '../../../../shared_elements/components';
import { regexConstants } from '../../../../constants/regEx';

export default class ManagementFee extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        const { type, invoiceInfo, invoice_item, index, newInvoiceDate } = this.props
        if (type === 'view') {
            return (
                <tr>
                    <td className="invoice-penalty-description-block" style={{ lineHeight: '5px', width: '200px' }}>
                        <h6 className="para-ui"> {newInvoiceDate ? invoice_item?.invoice_item_name : invoice_item?.invoice_item_name || '--'}</h6><br />
                    </td>
                    <td className="invoice-penalty-description-block" style={{ lineHeight: '5px', width: '150px' }}>
                        <h6 className="para-ui"> {newInvoiceDate ? invoice_item?.description : invoice_item?.description || '--'}</h6><br />
                    </td>
                    <td>
                        <h6 className="para-ui">
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoice_item?.rental_amount ? invoice_item?.rental_amount : '0'}
                            </NumericLabel>
                        </h6>
                    </td>
                    <td>
                        <h6 className="para-ui"> {invoice_item?.management_tax ? invoice_item.management_tax : '0'}%</h6>
                    </td>
                    <td style={{ width: '150px' }}>
                        <h6 className="para-ui" >
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoice_item?.management_tax_amount ? invoice_item.management_tax_amount : '0'}
                            </NumericLabel>
                        </h6>
                    </td>
                    <td>
                        <h6 className="para-ui"> {invoice_item?.vat_tax ? invoice_item.vat_tax : '0'}%</h6>
                    </td>
                    <td>
                        <h6 className="para-ui">
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoice_item?.vat_tax_amount ? invoice_item.vat_tax_amount : '0'}
                            </NumericLabel>
                        </h6>
                    </td>
                    <td>
                        <h6 className="para-ui">
                            <div style={{ display: 'flex', justifyContent:'right', alignItems:'center', gap:2}}>
                                <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                    {invoice_item?.sub_total ? invoice_item.sub_total : 0}
                                </NumericLabel>
                                {invoice_item?.excess_amount > 0 ?
                                    <Tooltip title={`Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${invoice_item.excess_amount}`}>
                                        <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                                    </Tooltip> : null}
                            </div>
                        </h6>
                    </td>
                </tr>
            )
        } else {
            return (
                <tr key={index}>
                    <td className="invoice-penalty-description-block" style={{ width: '200px' }}>
                        <h6 className="para-ui"> {invoice_item?.invoice_item_name || '--'}</h6>
                    </td>
                    <td className="invoice-penalty-description-block" style={{ width: '150px' }}>
                        <h6 className="para-ui"> {invoice_item?.description || '--'}</h6>
                    </td>
                    <td>
                        <h6 className="para-ui">
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoice_item?.rental_amount ? invoice_item?.rental_amount : '0'}
                            </NumericLabel>
                        </h6>
                    </td>
                    <td style={{ width: '100px' }}>
                        <input type="text" value={invoice_item?.management_tax ? invoice_item.management_tax : ''}
                            onChange={(e) => regexConstants.percantageRegExp.test(e.target.value) ? this.props.updateInvoiceItemField(e.target.value, 'management_tax', index) : e.preventDefault()}
                        />
                    </td>
                    <td style={{ width: '150px' }}>
                        <h6 className="para-ui">
                            <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                                {invoice_item?.management_tax_amount ? invoice_item?.management_tax_amount : '0'}
                            </NumericLabel>
                        </h6>
                    </td>
                    <td style={{ width: '100px' }}>
                        <input type="text" value={invoice_item?.vat_tax ? invoice_item.vat_tax : ''}
                            onChange={(e) => regexConstants.percantageRegExp.test(e.target.value) ? this.props.updateInvoiceItemField(e.target.value, 'vat_tax', index) : e.preventDefault()}
                        />
                    </td>
                    <td style={{ width: '150px' }}>
                        <h6 className="para-ui">
                            <NumericLabel params={showCurrencyFormat()}>
                                {invoice_item?.vat_tax_amount ? invoice_item?.vat_tax_amount : '0'}
                            </NumericLabel>
                        </h6>
                    </td>
                    <td>
                        <h6 className="para-ui">
                            <NumericLabel params={showCurrencyFormat()}>
                                {invoice_item.sub_total}
                            </NumericLabel>
                        </h6>
                    </td>
                </tr>
            )
        }
    }
}
